import qs from 'qs';
import { api } from 'src/api/api';
import { StrapiResponse } from 'src/types/http';
import { Institution } from 'src/types/institution';
import {
  Emission,
  Profitability,
  QuotaValue,
  Subordination,
} from 'src/types/operations/fidc';

export const getQuotaValuesDataCharts = async (
  operationId: string,
  defaultPeriodDate: string | null,
) => {
  const query = qs.stringify({
    filters: {
      operationid: operationId,
      ...(defaultPeriodDate && {
        data: {
          $gte: defaultPeriodDate,
        },
      }),
    },
    pagination: {
      page: 1,
      pageSize: 9999999999,
    },
  });
  const { data } = await api.get<StrapiResponse<QuotaValue[]>>(
    `/meta-cotas-diarias-vert-valor-unitario-quantidade-e-pls?${query}`,
  );
  return data.data;
};

export const getEmissionDataCharts = async (
  operationId: string,
  defaultPeriodDate: string | null,
) => {
  const query = qs.stringify({
    filters: {
      operationid: operationId,
      ...(defaultPeriodDate && {
        data: {
          $gte: defaultPeriodDate,
        },
      }),
      tipo: {
        $containsi: 'emissao',
      },
    },
    pagination: {
      page: 1,
      pageSize: 9999999999,
    },
  });
  const { data } = await api.get<StrapiResponse<Emission[]>>(
    `/meta-cotas-diarias-vert-emissao-amortizacao-e-resgatess?${query}`,
  );

  return data.data;
};

export const getAmortizationRedemptionsDataCharts = async (
  operationId: string,
  defaultPeriodDate: string | null,
) => {
  const query = qs.stringify({
    filters: {
      operationid: operationId,
      ...(defaultPeriodDate && {
        data: {
          $gte: defaultPeriodDate,
        },
      }),
      $or: [
        { tipo: { $containsi: 'amortizacao' } },
        { tipo: { $containsi: 'resgate' } },
      ],
    },
    pagination: {
      page: 1,
      pageSize: 9999999999,
    },
  });
  const { data } = await api.get<StrapiResponse<Emission[]>>(
    `/meta-cotas-diarias-vert-emissao-amortizacao-e-resgatess?${query}`,
  );

  return data.data;
};

export const getSubordinationDataCharts = async (
  operationId: string,
  defaultPeriodDate: string | null,
) => {
  const query = qs.stringify({
    filters: {
      operationid: operationId,
      ...(defaultPeriodDate && {
        data: {
          $gte: defaultPeriodDate,
        },
      }),
      ismulticlasse: true,
    },
    pagination: {
      page: 1,
      pageSize: 9999999999,
    },
  });
  const { data } = await api.get<StrapiResponse<Subordination[]>>(
    `/meta-cotas-diarias-vert-subordinacaos?${query}`,
  );

  return data.data;
};

export const getOperationDailyQuotaProvider = async (hashId: string) => {
  const { data } = await api.get<Institution[]>(
    `/operations-daily-quota-provider/${hashId}`,
  );

  return data;
};

export const getProfitabilityTableColumns = async (operationId: string) => {
  const { data } = await api.get<{ column_name: string }[]>(
    `meta-cotas-diarias-vert-rentabilidade/columns?operationId=${operationId}`,
  );
  return data;
};

export const getProfitabilityDataCharts = async (
  operationId: string,
  defaultPeriodDate: string | null,
) => {
  const query = qs.stringify({
    filters: {
      operationid: operationId,
      ...(defaultPeriodDate && {
        data: {
          $gte: defaultPeriodDate,
        },
      }),
    },
    pagination: {
      page: 1,
      pageSize: 9999999999,
    },
  });
  const { data } = await api.get<StrapiResponse<Profitability[]>>(
    `/meta-cotas-diarias-vert-rentabilidades?${query}`,
  );

  return data.data;
};
